import React, { useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { selectToken } from "../../utility/Redux/security";
import { selectPrefix, selectWidth } from "../../utility/Redux/profile";
import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from "../../utility/Redux/modal";
import uniqueId from "uniqid";

import ModalHeaderStyle from "../../utility/component/styles/modalHeader";
import {
  ModifyButton,
  SaveButton,
  UndoButton,
} from "../../utility/component/buttons";
import BasicInformation from "./basicInformation";
import AddressInformation from "./addressInformation";
import PartyList from "./partyList copy";
import AccountMasterHelp from "../../help/listAccountMasterHelp";
import { PartyColumns } from "./columns";
import { CallAPIPromise } from "../../billing/common";
import { getCountryInfo, GetCoutryList } from "../../utility/functions/common";
import BalanceSheethelp from "../../help/balanceSheetHeadHelp";
import EditableDataGrid from "../../utility/component/datagrid/editableDatagrid";
import { AccountLedgerColumns } from "../../VouhcerEntery/columns";
import { getAccountByNumber } from "../../utility/constant";
import {
  emtyRowDetailSAccountLedger,
  enterRowWithAccountDetails2,
  FirstIcodeItem2,
} from "../../VouhcerEntery/fun";
import AlertModalTwoButton from "../../utility/component/modals/alertWithTwoButton";
import { useFocus } from "../../utility/hooks/hooks";

const Party_Master = ({ hidePartyList, onClose, afterCreate }) => {
  const headerRef = useRef();
  const inputRef = useRef();
  const width = useSelector(selectWidth);
  const [rowId, setRowId] = useState("");
  const [searchText, setSearchText] = useState("");

  const [id, setId] = useState("");
  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: "",
    msg: "",
    status: false,
    setStatus: "",
    button1: "",
    button1Click: "",
    button2: "",
    button2Click: "",
  });
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const [partyMasterHelpStatus, setPartyMasterhelpStatus] = useState(false);
  const [stationName, setStationName] = useState("");
  const prefix = useSelector(selectPrefix);
  const [selectedItemPage, setSelectedItemPage] = useState("Basic Info");
  const otherDemoData = {
    OPENING_BALANCE: 0,
    OPENING_BALANCE_TYPE: "Cr",
    REMARKS: "",
    TAX_CATEGORY: "GST",
    TDS_RATE: "0",
    INTEREST_RATE: "0",
    TAX_RATE: "0",
    UNDER_GROUP_CODE: "",
    UNDER_GROUP: "",
    ROOT_GROUP: "",
    BALANCE_SHEET_CLASS: "",
    BALANCE_SHEET_SIDE: "",
  };
  const [helpStatus, setHelpStatus] = useState(false);

  const [otherData, setotherData] = useState(otherDemoData);
  const [countryList, setCountryList] = useState([]);
  const [statesList, setStateslist] = useState([]);
  const [citysList, setCityslist] = useState([]);
  const [tabScreen, setTabScreen] = useState(1);
  const [partyName, setPartyName] = useState("");
  const [accountNo, setAccountNo] = useState("");
  const [gstNo, setGstNo] = useState("");
  const [panNo, setPanNo] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [creditAllow, setCreditAllow] = useState("");
  const [creditPeriod, setCreditPeriod] = useState("");
  const [stationId, setStationId] = useState("");
  const [latitude, setlatitude] = useState("123");
  const [longitude, setLongitude] = useState("123");
  const [address, setAddress] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [city, setCity] = useState("");
  const [taxRateRef, setTaxRateFocus] = useFocus();

  const [currencySymbol, setCurrencySymbol] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [fullList, setFullList] = useState([]);
  const [parties, setParties] = useState([]);
  const [stop, setStop] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [stateList, setStatelist] = useState([]);
  const [cityList, setCitylist] = useState([]);
  const [missingId, setMissingId] = useState("partyName");
  const [addressMissingId, setAddressMissingId] = useState("address");
  const [rows, setRows] = useState([
    {
      ...emtyRowDetailSAccountLedger,
      id: uniqueId(),
    },
  ]);
  const [selectedCountry, setSelectedCountry] = useState("");

  const handleCountryChange = async (e) => {
    return new Promise((resolve, reject) => {
      setSelectedCountry(e.target.value);
      const countryDetails = countryList.filter(
        (c) => c.countryName === e.target.value
      );
      if (countryDetails[0]) {
        getCountryInfo(countryDetails[0].geonameId).then((res) => {
          setStateslist(res?.data?.geonames ? res?.data?.geonames : []);
          resolve(res?.data?.geonames ? res?.data?.geonames : []);
        });
      }
    });
  };

  const deletRow = (id) => {
    setRows((o) => {
      const list = o.filter((r) => r.id !== id);
      if (list.find((o) => o.TAX_ACCOUNT_NAME === "")) {
        return list;
      } else {
        return [
          ...list,
          {
            ...emtyRowDetailSAccountLedger,
            id: uniqueId(),
          },
        ];
      }
    });
  };
  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    const states = e.target.list ? e.target.list : statesList;
    const stateDetails = states.filter((c) => c.name === e.target.value);
    if (stateDetails[0]) {
      getCountryInfo(stateDetails[0].geonameId).then((res) => {
        setCityslist(res?.data?.geonames ? res?.data?.geonames : []);
      });
    }
  };

  const phoneRegex = /^[6-9]\d{9}$/;
  useEffect(() => {
    GetCoutryList().then((res) => {
      setCountryList(res.data.geonames);
    });
  }, []);
  const savePartyMasterApi = () => {
    if (
      (partyName.includes("%") && otherData.TAX_RATE > 0) ||
      !partyName.includes("%")
    ) {
      if (!rows.find((r) => r.TAX_ACCOUNT_NAME && !r.PERCENTAGE)) {
        if (partyName && otherData.UNDER_GROUP_CODE) {
          const data = {
            table_prefix: prefix,
            ACCOUNT_NO: id ? id : "",
            NAME: partyName,
            TAX_NUMBER: gstNo,
            PAN: panNo,
            ADDRESS: address,
            COUNTRY: selectedCountry,
            CURRENCY_SYMBOL: currencySymbol,
            CURRENCY_NAME: currencyName,
            STATE: selectedState,
            CITY: city,
            PIN_CODE: pinCode,
            PHONE: phoneNo,
            MOBILE: mobile,
            EMAIL: email,
            WEBSITE: website,
            OPENING_BALANCE: otherData.OPENING_BALANCE
              ? Number(otherData.OPENING_BALANCE)
              : 0,
            OPENING_BALANCE_TYPE: otherData.OPENING_BALANCE_TYPE
              ? otherData.OPENING_BALANCE_TYPE
              : "Dr",
            CREDIT_LIMIT_PERIOD: creditPeriod ? Number(creditPeriod) : 0,
            CREDIT_LIMIT_ALLOWED: Number(creditAllow),
            LATITUDE: latitude ? latitude : "",
            LONGITITUDE: longitude ? longitude : "",
            REMARKS: otherData.REMARKS ? otherData.REMARKS : "",
            TAX_CATEGORY: otherData.TAX_CATEGORY ? otherData.TAX_CATEGORY : "",
            TDS_RATE: otherData.TDS_RATE ? otherData.TDS_RATE : "0",
            INTEREST_RATE: otherData.INTEREST_RATE
              ? otherData.INTEREST_RATE
              : "0",
            TAX_RATE: otherData.TAX_RATE ? otherData.TAX_RATE : "0",
            UNDER_GROUP_CODE: otherData.UNDER_GROUP_CODE,
            UNDER_GROUP: otherData.UNDER_GROUP,
            ROOT_GROUP: otherData.ROOT_GROUP,
            BALANCE_SHEET_CLASS: otherData.BALANCE_SHEET_CLASS,
            BALANCE_SHEET_SIDE: otherData.BALANCE_SHEET_SIDE,
            account_master_tax_cart: rows.filter(
              (r) =>
                r.PERCENTAGE !== "" && r.PERCENTAGE > 0 && r.TAX_ACCOUNT_NAME
            ),
          };

          {
            id
              ? dispatch(setSpinnerLoading("Updating"))
              : dispatch(setSpinnerLoading("Saving"));
          }

          CallAPIPromise(`/api/accountMaster/saveAccountMaster`, data, token)
            .then(async function (response) {
              if (!response.data.error) {
                clearState();
                if (afterCreate) {
                  afterCreate();
                }
                id
                  ? dispatch(
                      setAlertWithTitle({
                        title: "Success.",
                        msg: "Data Updated successfully.",
                        lottie: "success",
                      })
                    )
                  : dispatch(
                      setAlertWithTitle({
                        title: "Success.",
                        msg: "Data Saved successfully.",
                        lottie: "success",
                      })
                    );
                setFullList([]);
              } else {
                dispatch(
                  setAlertWithTitle({
                    title: "Error 112",
                    msg: response.data.error,
                  })
                );
              }
            })
            .catch(function (error) {
              if (error.response.data.name === "TokenExpiredError") {
                dispatch(setSessionExpired(true));
              } else {
                dispatch(
                  setAlertWithTitle({
                    title: "ERROR",
                    msg: "Something went wrong",
                    lottie: "reject",
                  })
                );
              }
            })
            .finally(() => {
              dispatch(setSpinnerLoading(false));
            });
        } else {
          if (!partyName) {
            setTabScreen(1);
            setMissingId("partyName");

            dispatch(
              setAlertWithTitle({
                title: "Alert",
                msg: "Please Enter Party Name.",
              })
            );
          } else {
            if (!otherData.UNDER_GROUP_CODE) {
              dispatch(
                setAlertWithTitle({
                  title: "Alert",
                  msg: "Please Select Under Group.",
                })
              );
            }
          }
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Percentage Missing",
            msg: "Percentage not found for 1 or more accounts. please add percantage or remove that account from list.",
          })
        );
        setTabScreen(3);
      }
    } else {
      setTaxRateFocus();
      dispatch(
        setAlertWithTitle({
          title: "Tax Rate",
          msg: "Tax Rate is required",
        })
      );
    }
  };
  const columns2 = AccountLedgerColumns(width);

  const keyDown2 = (e, currentFieldName, id) => {
    const value = e.target.value;
    if (currentFieldName === "TAX_ACCOUNT_NO" && e.code === "F4") {
      setRowId(id);
      setPartyMasterhelpStatus(true);
      return;
    }

    if (
      (currentFieldName === "TAX_ACCOUNT_NO" &&
        e.code === "Enter" &&
        value !== "" &&
        value !== "0") ||
      (e.code === "NumpadEnter" &&
        value !== "" &&
        value !== "0" &&
        currentFieldName === "TAX_ACCOUNT_NO")
    ) {
      if (!isNaN(value)) {
        const v = value.toString().replace(" ", "");
        if (v) {
          const isFilled = rows.find((r) => r.id === id);
          if (!isFilled?.TAX_ACCOUNT_NAME) {
            if (
              !rows.find((o) => {
                if (o.TAX_ACCOUNT_NAME) {
                  if (Number(o.MOBILE) === Number(value) && o.id !== id) {
                    return o; // Return the object if condition matches
                  }
                  if (
                    o?.TAX_ACCOUNT_NO?.toString() === value.toString() &&
                    o.id !== id
                  ) {
                    return o; // Return the object if condition matches
                  }
                }
                return false;
              })
            ) {
              if (
                e.code === "Enter" ||
                e.code === "NumpadEnter" ||
                e.code === "ArrowRight"
              ) {
                const currentFieldIndex = columns2.findIndex(
                  (column) => column.field === currentFieldName
                );
                const nextEditableField = columns2.find(
                  (column, index) =>
                    index > currentFieldIndex && columns2.editable
                );
                if (nextEditableField) {
                  const nearestInput = document.getElementById(
                    id + "-" + nextEditableField.field
                  );
                  setTimeout(() => {
                    if (nearestInput) {
                      nearestInput.focus();
                      nearestInput.select();
                    }
                  }, 2000);
                }
              }
              getAccountByNumber(
                prefix,
                "",
                token,
                dispatch,
                "",
                value,
                true
              ).then((codeItem) => {
                if (!codeItem[0]) {
                  getAccountByNumber(
                    prefix,
                    value,
                    token,
                    dispatch,
                    "",
                    "",
                    false
                  ).then((aliosItem) => {
                    enterRowWithAccountDetails2(
                      aliosItem.map((o) => {
                        return {
                          ...o,
                          TAX_ACCOUNT_NAME: o.NAME,
                          TAX_ACCOUNT_NO: o.ACCOUNT_NO,
                        };
                      }),
                      rows,
                      id,
                      dispatch,
                      setRows,
                      value,
                      setAlertTwoButtonModal,
                      () => {}
                    );
                  });
                } else {
                  enterRowWithAccountDetails2(
                    codeItem.map((o) => {
                      return {
                        ...o,
                        TAX_ACCOUNT_NAME: o.NAME,
                        TAX_ACCOUNT_NO: o.ACCOUNT_NO,
                      };
                    }),
                    rows,
                    id,
                    dispatch,
                    setRows,
                    value,
                    setAlertTwoButtonModal,
                    () => {}
                  );
                }
              });
            } else {
              setAlertTwoButtonModal((o) => {
                return {
                  ...o,
                  status: true,
                  title: "Alert",
                  msg: "Party already exist",
                  button1: "ok",
                  button1Click: () => {
                    setAlertTwoButtonModal((o) => {
                      return {
                        ...o,
                        status: false,
                      };
                    });
                  },
                };
              });
            }
          } else {
            const currentFieldIndex = columns2.findIndex(
              (column) => column.field === currentFieldName
            );
            const nextEditableField = columns2.find(
              (column, index) => index > currentFieldIndex && column.editable
            );
            if (nextEditableField) {
              const nearestInput = document.getElementById(
                id + "-" + nextEditableField.field
              );
              if (nearestInput) {
                nearestInput.focus();
                nearestInput.select();
              }
            }
          }
        } else {
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "Please enter Icode to continue",
            })
          );
        }
      } else {
        setRows((r) =>
          r.map((o) => {
            if (o.id === id) {
              return {
                ...o,
                TAX_ACCOUNT_NO: "",
              };
            } else {
              return o;
            }
          })
        );
        setSearchText(value);
        setRowId(id);
        setPartyMasterhelpStatus(true);
      }
    } else {
      if (currentFieldName === "TAX_ACCOUNT_NO") {
        setAlertTwoButtonModal({
          status: true,
          title: "Alert",
          msg: "Please Enter Tax Account Number First.",
          button1: "ok",

          button1Click: () => {
            setAlertTwoButtonModal({
              ...alertTwoButtonModal,
              status: false,
            });
          },
        });
      } else {
        if (
          e.code === "Enter" ||
          e.code === "NumpadEnter" ||
          e.code === "ArrowRight"
        ) {
          const currentFieldIndex = columns2.findIndex(
            (column) => column.field === currentFieldName
          );
          const nextEditableField = columns2.find(
            (column, index) => index > currentFieldIndex && column.editable
          );
          if (nextEditableField) {
            const nearestInput = document.getElementById(
              id + "-" + nextEditableField.field
            );
            if (nearestInput) {
              nearestInput.focus();
              nearestInput.select();
            }
          }
        }
      }
    }
  };
  const clearState = () => {
    setotherData(otherDemoData);
    setId("");
    setRows([
      {
        ...emtyRowDetailSAccountLedger,
        id: uniqueId(),
      },
    ]);
    setPartyName("");
    setGstNo("");
    setPanNo("");
    setPhoneNo("");
    setMobile("");
    setEmail("");
    setWebsite("");
    setCreditAllow("");
    setCreditPeriod("");
    setStationId("");
    setlatitude("");
    setLongitude("");
    setAddress("");
    setSelectedCountry("");
    setSelectedState("");

    setCity("");
    setPinCode("");
    setCurrencySymbol("");
    setCurrencyName("");
    setAccountNo("");
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.altKey && e.key === "s") {
        e.preventDefault();
        savePartyMasterApi();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    id,
    partyName,
    gstNo,
    panNo,
    phoneNo,
    mobile,
    email,
    website,
    creditAllow,
    creditPeriod,

    stationId,
    address,
    city,
    selectedCountry,
    selectedState,
    stop,
    accountNo,
    otherData,
  ]);

  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/masters");
  };

  const coloumns = PartyColumns(width);
  const partyRef = useRef(null);
  const addressRef = useRef(null);

  useEffect(() => {
    if (partyRef && tabScreen === 1) {
      const inputFields = partyRef.current.querySelectorAll("input, select");

      // Add a keydown event listener to each input and select field
      inputFields.forEach((field, index) => {
        field.addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
            event.preventDefault(); // Prevent form submission
            const nextIndex = (index + 1) % inputFields.length;
            inputFields[nextIndex].focus();
          }
        });
      });

      // Cleanup event listeners on unmount
      return () => {
        inputFields.forEach((field) => {
          field.removeEventListener("keydown", () => {});
        });
      };
    }
  }, [tabScreen]);
  const delayedFunction = (id) => {
    setTimeout(() => {
      // Function to execute after 30 seconds
      const nearestInput = document.getElementById(id + "-" + "TAX_ACCOUNT_NO");
      if (nearestInput) {
        nearestInput.focus();
      }
    }, 200);
  };
  useEffect(() => {
    if (missingId) {
      const inputFields = partyRef.current.querySelectorAll("input, select");
      inputFields.forEach((element) => {
        if (element.id === missingId) {
          element.focus();
          setMissingId("");
        }
      });
    }
  }, [missingId]);
  const nextRow2 = (index) => {
    delayedFunction(rows[index].id);
  };

  const CellEdit2 = ({ id, field, value }) => {
    if (field === "TAX_ACCOUNT_NO") {
      const isSameIdExist = rows.filter((row) => row.id === id);
      if (isSameIdExist[0]) {
        setRows((old) =>
          old.map((item) => {
            if (item.id === id && !item.TAX_ACCOUNT_NAME) {
              return {
                ...item,
                TAX_ACCOUNT_NO: value,
              };
            } else {
              return item;
            }
          })
        );
      } else {
        setRows((old) => {
          return [
            ...old,
            {
              ...old[0],
            },
          ];
        });
      }
    }

    if (field === "PERCENTAGE") {
      const updatedRows = rows.map((row) => {
        if (row.id === id) {
          const item = rows.filter((i) => i.id === id);

          const i = FirstIcodeItem2(id, {
            ...item[0],
            [field]: value,
          });
          return i;
        }
        return row;
      });

      setRows(updatedRows);
    }
  };
  return (
    <div className="w-full h-full  bg-[#f5f5f7]   max-sm:py-2 ">
      <div
        style={{
          paddingTop: !hidePartyList ? "16px" : "0px",
          paddingBottom: !hidePartyList ? "16px" : "0px",
        }}
        className="flex justify-center container  h-full "
      >
        <div
          style={{ borderRadius: "12px", height: "100%" }}
          className=" flex items-center h-full overflow-y-auto"
        >
          <div className="h-full flex flex-col">
            <div ref={headerRef}>
              <ModalHeaderStyle
                header={"Party Master"}
                onClose={onClose ? onClose : handleClose}
              />
            </div>
            <div
              style={{
                height: `calc(100% - 80px)`,
              }}
              className="  rounded-b-sm bg-white w-full flex flex-col "
            >
              <div className="h-full flex flex-col w-full ">
                <div className=" flex border-b drop-shadow-sm p-2 h-fit justify-between pb-2 ">
                  <div className="ms:hidden md:flex  ">
                    {["Party Details", "Address Details", "Voucher Tax"].map(
                      (t) => {
                        return (
                          <a
                            style={{
                              textDecoration: "none",
                              color: "black",
                              fontSize: "14px",
                              border: `1px ${
                                selectedItemPage === t ? "solid" : "dotted"
                              } gray`,
                              marginRight: 3,
                            }}
                            onClick={() => {
                              if (t === "Voucher Tax") {
                                setTabScreen(3);
                                setSelectedItemPage(t);
                              } else {
                                if (tabScreen === 3) {
                                  if (
                                    rows.find(
                                      (o) =>
                                        (!o.PERCENTAGE || o.PERCENTAGE < 1) &&
                                        o.TAX_ACCOUNT_NAME
                                    )
                                  ) {
                                    dispatch(
                                      setAlertWithTitle({
                                        title: "Alert",
                                        msg: "Found 1 row without percentage remove it or enter percantage",
                                      })
                                    );
                                    return;
                                  }
                                }
                                setTabScreen(1);
                                setSelectedItemPage(t);
                              }
                            }}
                            href={`/account_master#${t}`}
                            className="py-2 px-6 rounded-sm  "
                          >
                            {t}
                          </a>
                        );
                      }
                    )}
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-1 gap-2 ">
                    <button
                      onClick={() => {
                        setTabScreen(1);
                      }}
                      className="py-2 px-6 ms:flex md:hidden bg-gradient-to-r from-[#f2f4f9] via-[#d9e0e2] to-[#b7c9c7] text-black rounded-sm flex items-center gap-2 hover:shadow-md transition-all duration-300"
                    >
                      <i
                        className="bi bi-database"
                        style={{ fontSize: "18px" }}
                      />{" "}
                      {/* Bootstrap Icon for Item Master */}
                      Party Master
                    </button>

                    <button
                      onClick={() => {
                        setTabScreen(2);
                      }}
                      className="py-2 px-6 bg-gradient-to-r from-[#f2f4f9] via-[#d9e0e2] to-[#b7c9c7] text-black rounded-sm flex items-center gap-2 hover:shadow-md transition-all duration-300"
                    >
                      <i
                        className="bi bi-list-ul"
                        style={{ fontSize: "18px" }}
                      />{" "}
                      {/* Bootstrap Icon for Item List */}
                      Party List
                    </button>
                  </div>
                </div>

                <div className=" flex flex-col scroll-container overflow-y-auto h-full mt-2  p-2">
                  <div className="h-full">
                    {tabScreen === 1 && (
                      <>
                        <div ref={partyRef}>
                          <BasicInformation
                            partyRef={partyRef}
                            partyName={partyName}
                            setPartyName={setPartyName}
                            accountNo={accountNo}
                            setAccountNo={setAccountNo}
                            gstNo={gstNo}
                            missingId={missingId}
                            setGstNo={setGstNo}
                            setHelpStatus={setHelpStatus}
                            panNo={panNo}
                            otherData={otherData}
                            setotherData={setotherData}
                            setPanNo={setPanNo}
                            phoneNo={phoneNo}
                            setPhoneNo={setPhoneNo}
                            mobile={mobile}
                            setMissingId={setMissingId}
                            setMobile={setMobile}
                            email={email}
                            setEmail={setEmail}
                            website={website}
                            setWebsite={setWebsite}
                            creditAllow={creditAllow}
                            creditPeriod={creditPeriod}
                            setCreditAllow={setCreditAllow}
                            setCreditPeriod={setCreditPeriod}
                            stationId={stationId}
                            setTabScreen={setTabScreen}
                            taxRateRef={taxRateRef}
                            setPartyMasterhelpStatus={setPartyMasterhelpStatus}
                          />
                          <AddressInformation
                            address={address}
                            setSelectedCountry={setSelectedCountry}
                            addressMissingId={addressMissingId}
                            setAddressMissingId={setAddressMissingId}
                            addressRef={addressRef}
                            setAddress={setAddress}
                            selectedState={selectedState}
                            setSelectedState={setSelectedState}
                            stateList={stateList}
                            setStatelist={setStatelist}
                            cityList={cityList}
                            city={city}
                            statesList={statesList}
                            citysList={citysList}
                            setCity={setCity}
                            setCitylist={setCitylist}
                            handleCountryChange={handleCountryChange}
                            countryList={countryList}
                            pinCode={pinCode}
                            setPinCode={setPinCode}
                            handleStateChange={handleStateChange}
                            selectedCountry={selectedCountry}
                            stop={stop}
                            setStop={setStop}
                            currencyName={currencyName}
                            currencySymbol={currencySymbol}
                            setCurrencyName={setCurrencyName}
                            setCurrencySymbol={setCurrencySymbol}
                            setTabScreen={setTabScreen}
                          />
                        </div>
                      </>
                    )}

                    {tabScreen === 2 && (
                      <PartyList
                        fullList={fullList}
                        setFullList={setFullList}
                        parties={parties}
                        setParties={setParties}
                        stationId={stationId}
                        stationName={stationName}
                        setStationId={setStationId}
                        setStationName={setStationName}
                      />
                    )}

                    {tabScreen === 3 && (
                      <div
                        id={"Party Details"}
                        className="grid h-full grid-cols-1  l:grid-cols-[200px,1fr] ll:grid-cols-[400px,1fr]  border-b pb-2 p-3 "
                      >
                        <div className="h-fit ms:hidden l:block">
                          <div className="font-semibold text-[16px] text-black  w-fit ">
                            Voucher Tax
                          </div>
                          <div className="text-[12px] text-gray-600  w-fit ">
                            Add Voucher Tax Details
                          </div>
                        </div>
                        <EditableDataGrid
                          nextRow={nextRow2}
                          keyDown={keyDown2}
                          columns={columns2}
                          data={rows}
                          deletRow={deletRow}
                          onEditCell={CellEdit2}
                          firstInputRef={inputRef}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {(tabScreen === 1 || tabScreen === 3) && (
                  <div className="flex justify-end p-3">
                    <div className="mr-1 ">
                      {id ? (
                        <ModifyButton onClick={savePartyMasterApi} />
                      ) : (
                        <SaveButton onClick={savePartyMasterApi} />
                      )}
                    </div>
                    <UndoButton onClick={clearState} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <BalanceSheethelp
        status={helpStatus}
        onRowClick={(p) => {
          setHelpStatus(false);
          setotherData((prev) => {
            return {
              ...prev,
              UNDER_GROUP_CODE: p.row.HEAD_NO,
              UNDER_GROUP: p.row.HEAD,
              ROOT_GROUP: p.row.BALANCE_SHEET_CLASS,
              BALANCE_SHEET_CLASS: p.row.BALANCE_SHEET_CLASS,
              BALANCE_SHEET_SIDE: p.row.BALANCE_SHEET_SIDE,
            };
          });
        }}
        onClose={() => {
          setHelpStatus(false);
        }}
      />
      <AlertModalTwoButton
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />
      <AccountMasterHelp
        status={partyMasterHelpStatus}
        onRowClick={(p) => {
          const partyName = p.row.NAME;

          const match = partyName.match(/(\d+(\.\d+)?)%/);
          if (tabScreen === 1) {
            setPartyName(p.row.NAME);
            setAccountNo(p.row.ACCOUNT_NO);
            setGstNo(p.row.TAX_NUMBER);
            setMobile(p.row.MOBILE);
            setEmail(p.row.EMAIL);
            setWebsite(p.row.WEBSITE);
            setCreditAllow(p.row.CREDIT_LIMIT_ALLOWED);
            setCreditPeriod(p.row.CREDIT_LIMIT_PERIOD);
            setStationId(p.row.SID);
            setlatitude(p.row.LATITUDE);
            setLongitude(p.row.LONGITUDE);
            setAddress(p.row.ADDRESS);
            setCity(p.row.CITY);
            setotherData({
              ...p.row,
            });
            setRows([
              ...p.row.TAX_ENTRIES,
              {
                ...emtyRowDetailSAccountLedger,
                id: uniqueId(),
              },
            ]);
            handleCountryChange({
              target: {
                value: p.row.COUNTRY,
              },
            }).then((list) => {
              handleStateChange({
                target: {
                  value: p.row.STATE,
                  list: list,
                },
              });
            });

            setPinCode(p.row.PIN_CODE);
            setId(p.row.ACCOUNT_NO);

            setPartyMasterhelpStatus(false);
            const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
            const match = p.row.TAX_NUMBER.match(panRegex);

            if (match) {
              setPanNo(match[0]);
            }
          } else {
            const d = {
              id: rowId,
              code: "Enter",
              target: {
                value: p.row.ACCOUNT_NO,
              },
            };
            setPartyMasterhelpStatus(false);
            keyDown2(d, "TAX_ACCOUNT_NO", d.id);
          }
        }}
        searchText={searchText}
        onClose={() => {
          setPartyMasterhelpStatus(false);
        }}
      />
    </div>
  );
};

export default Party_Master;
